<template>
  <section class="container-section">
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Transporte Internacional
        </h3>
      </section>
      <section>
        <div class="uk-form-controls uk-margin">
          <div>
            <div class="title-radio">
              <label
                class="labeltext"
                style="font-weight:600"
              >Formato de Envío</label>
            </div>

            <div class="uk-flex uk-flex-between uk-flex-wrap uk-margin-bottom">
              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="internationalTransport.quoteCurrency"
                    class="uk-radio"
                    type="radio"
                    name="radio1"
                    :value="shippingCoinEnum.coinRD"
                  > Pesos Dominicanos (RD$)</label>
              </div>
              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="internationalTransport.quoteCurrency"
                    class="uk-radio"
                    type="radio"
                    name="radio1"
                    :value="shippingCoinEnum.coinUSA"
                  > Dolares Americanos (USD)</label>
              </div>

              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="internationalTransport.quoteCurrency"
                    class="uk-radio"
                    type="radio"
                    name="radio1"
                    :value="shippingCoinEnum.bothCoin"
                  > Ambas Monedas</label>
              </div>
            </div>
          </div>
          <div>
            <div class="title-radio">
              <label
                class="labeltext"
                style="font-weight:600"
              >Dirección del Flete</label>
            </div>

            <div class="uk-flex uk-flex-between uk-flex-wrap uk-margin-bottom">
              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="internationalTransport.freightAddress"
                    class="uk-radio"
                    type="radio"
                    name="radio2"
                    :value="freightAddressEnum.importation"
                  > Importación</label>
              </div>
              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="internationalTransport.freightAddress"
                    class="uk-radio"
                    type="radio"
                    name="radio2"
                    :value="freightAddressEnum.exportation"
                  > Exportación</label>
              </div>

              <div class="items">
                <label style="cursor: pointer">
                  <input
                    v-model="internationalTransport.freightAddress"
                    class="uk-radio"
                    type="radio"
                    name="radio2"
                    :value="freightAddressEnum.transit"
                  > Tránsito</label>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-form-controls uk-margin uk-flex uk-flex-between uk-flex-wrap">
          <div class="items-select uk-display-inline-block">
            <label>
              Flete incluye costos de terminal
              <select
                v-model="internationalTransport.freightIncludesTerminalCosts"
              >
                <option :value="true">Si</option>
                <option :value="false">No</option>
              </select>
            </label>
          </div>

          <div class="items-select uk-display-inline-block">
            <label>
              Flete incluye transporte terrestre fuera de RD
              <select
                v-model="internationalTransport.freightIncludesGroundTransportationOutsideRD"
              >
                <option :value="true">Si</option>
                <option :value="false">No</option>
              </select>
            </label>
          </div>
        </div>
        <div v-if="transportMode === transportModeTypeEnum.aerial">
          <a
            target="_blank"
            href="https://aerodom.com/en/home/"
          >
            <img
              src="../../../assets/img/international-airplane.jpg"
              alt=""
            >
          </a>
        </div>

        <div v-if="transportMode === transportModeTypeEnum.maritime">
          <a
            target="_blank"
            href="https://asociacionavieros.com/es/"
          >
            <img
              src="../../../assets/img/international-boat.jpg"
              alt=""
            >
          </a>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { shippingCoinEnum, freightAddressEnum, transportModeTypeEnum } from '../../../types'

export default {
  data () {
    return {
      shippingCoinEnum,
      freightAddressEnum,
      transportModeTypeEnum,

      internationalTransport: {
        quoteCurrency: 1,
        freightAddress: 1,
        freightIncludesTerminalCosts: null,
        freightIncludesGroundTransportationOutsideRD: null

      }
    }
  },

  computed: {
    ...mapGetters([
      'transportMode',
      'internationalTransportStore'

    ])
  },

  watch: {
    internationalTransport: {
      handler: function (newVal) {
        this.$store.commit('setInternationalTransport', newVal)
      },
      deep: true
    }
  },

  mounted () {
    this.internationalTransport = { ...this.internationalTransportStore }
  }

}
</script>

<style scoped>
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
.container-section{
  width: 90%;
  padding: 10px 40px;
}

.sub-container{
  min-height: 418px;;
}
section{
  padding: 10px 10px 30px;
}
.title-radio{
  margin-bottom: 15px;
}
.title{
  font-weight: 600;
  margin-bottom: 10px;

}
.items label{
  display: flex;
  align-items: center ;
}
.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}

.uk-radio{
  margin: 7px 2px 7px 0px
}
.items-select{
  margin: 15px 10px 15px 0px;

}

.items{
  margin: 0px 10px;
}
.labeltext {
  font-weight:600;
  color: #333 !important;
  margin-bottom: 15px;
}

@media screen and (max-width: 879px){
  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }

  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
    padding: 0px;
  }
    .container-section{
  padding: 10px 20px;
  width: 100%;
}
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  .title-radio{
       margin-bottom: 10px;
  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
}
@media screen and (max-width: 389px){
  .items{
    margin: 0px 10px 0px 0px;
  }
}
</style>
